// has-role.directive.ts
import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy, effect, inject } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { RoleEnum } from '../consts/role.const';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective implements OnDestroy {
  private requiredRoles: string[] | RoleEnum[] = [];
  private authService = inject(AuthService);
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);

  constructor() {
    effect(() => {
      this.authService.selectedRole();
      this.updateView();
    });
  }

  @Input() set appHasRole(roles: string[] | RoleEnum[]) {
    this.requiredRoles = roles;
    this.updateView();
  }

  private updateView(): void {
    this.viewContainer.clear();
    
    if (!this.requiredRoles || !this.requiredRoles.filter(Boolean).length) {
      return;
    }

    const hasRole = this.authService.hasRequiredRole(this.requiredRoles);
    if (hasRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  ngOnDestroy(): void {
  }
}